import React from "react";
import RecurringSummaryHistory from "./RecurringSummaryHistory";

/**
 * @param {object} props
 * @param {object} props.control
 * @returns {React.JSX.Element}
 */
const ConnectedRecurringSummaryHistory = ({ control }) => {
    const { options = {} } = control;
    const {
        accordionAdditionalText = "See a record of all gifts and receipts.",
        accordionLabel = "Your History",
    } = options;

    const recurringSummaryHistoryProps = {
        accordionAdditionalText,
        accordionLabel,
        control,
    };

    return <RecurringSummaryHistory {...recurringSummaryHistoryProps} />;
};

export default ConnectedRecurringSummaryHistory;
